module.exports = __webpack_public_path__ + "static/img/baojingqueren2.bc1e519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/baojingqueren2.png
// module id = RVYa
// module chunks = 24